"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dispatch_1 = require("./dispatch");
var functionInternals_1 = require("./functionInternals");
function action(actionType, actionContext) {
    return function createAction(arg0, arg1, arg2) {
        if (arguments.length == 1 && typeof arg0 == 'function') {
            return wrapFunctionInAction(arg0, actionType, actionContext);
        }
        else {
            decorateClassMethod(arg0, arg1, arg2, actionType, actionContext);
        }
    };
}
exports.default = action;
function wrapFunctionInAction(target, actionType, actionContext) {
    var decoratedTarget = function () {
        var _this = this;
        var returnValue;
        var passedArguments = arguments;
        dispatch_1.default(function () {
            returnValue = target.apply(_this, passedArguments);
            return returnValue;
        }, actionType, arguments, actionContext);
        return returnValue;
    };
    functionInternals_1.setOriginalTarget(decoratedTarget, target);
    functionInternals_1.setActionType(decoratedTarget, actionType);
    return decoratedTarget;
}
function decorateClassMethod(target, propertyKey, descriptor, actionType, actionContext) {
    if (descriptor && typeof descriptor.value == 'function') {
        descriptor.value = wrapFunctionInAction(descriptor.value, actionType, actionContext);
    }
    else {
        throw new Error('The @action decorator can only apply to class methods.');
    }
}
